<template>
  <div class="stage">
    <div class="container">
      <div class="row">
        <div class="col-lg-2 d-12 d-lg-inline-block">
          <slot v-if="this.showLeftColumn()" name="stage-left"></slot>
        </div>
        <div
          :class="
            this.showLeftColumn()
              ? 'col-12 col-lg-10'
              : 'col-12 col-lg-10 offset-lg-1'
          "
        >
          <slot name="stage-main"></slot>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      //
    };
  },

  methods: {
    showLeftColumn() {
      return this.$slots["stage-left"];
    },
  },
};
</script>

<style scoped>
/*
.stage {
  background-image: url("../assets/bg_small.jpg");
  background-size: 40% auto; 
  padding: 20px 0 60px 0;
}
@media (min-width: 768px) {
  .stage {
    background-image: url("../assets/bg_small.jpg");
    min-height: 675px;
  }
}
*/
</style>
